<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{{ this.title }}</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            background-color: #d5d5d5;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            margin: 0;
        }

        .popup {
            background: white;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            text-align: center;
            min-width: 350px;
            border-top: 4px solid #007bff;
            position: relative;
        }

        .popup h2 {
            margin-top: 10px;
            color: #333;
            font-size: 20px;
        }

        .popup p {
            font-size: 14px;
            color: #555;
        }
    </style>
</head>

<body>
    <div class="popup">
        <div class="item-center m-4">
            <mat-icon svgIcon="falInfoCircle" class="icon-size-50 icon-center font-natural-gray"></mat-icon>
        </div>
        <h2>{{ this.title }}</h2>
        <div class="mt-2 mb-4 text-center font-content-empty-msg">
            <p class="mt-2">{{ this.message }}</p>
        </div>
        <p>{{ this.footer }}</p>
    </div>
</body>

</html>